.root {
  color-scheme: inherit;
  font: inherit;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  display: inline-block;
}

.root:is([data-focus-visible], [data-focus-visible-addded]) {
  outline: none;
}

.root:not([data-disabled]) {
  cursor: pointer;
}

.root[data-disabled] {
  cursor: not-allowed;
}

.root:is(a):is([data-hovered], [data-focus-visible], [data-focus-visible-addded]) {
  /** Only pure-text links should be underlined if not excplicitely allowed otherwise */
  &.decoration-text:not(:has(*)) {
    text-decoration: underline;
  }

  &.decoration-all {
    text-decoration: underline;
  }
}

.root:not(a, [data-hovered], [data-focus-visible], [data-focus-visible-addded]),
.decoration-none {
  /** TODO remove !important when we get rid of Primer's base styles */
  text-decoration: none !important;
}

.root:is(:link, :active, :visited) {
  &:not(.color-inherit) {
    color: var(--color__gray-950);
  }

  &.color-inherit {
    color: inherit;
  }
}
